<template>
  <div>
    <PCNavbar selectIndex="4" pageType="Pioneer"/>
    <!-- <MobileNavBar :currentActive="3" /> -->
     <Sustainability />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Sustainability from '@/components/sustainability/index.vue'
export default {
  components: {
    PCNavbar,
    Sustainability
    // MobileNavBar
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style>
</style>